<style lang="scss">
  .modal{
    &__header{
      padding: 20px;
      text-align: center;
      border-bottom: 1px solid #E3E6EB;
    }

    &__full-border{
      border-bottom: 1px solid #E3E6EB;
    }

    &__padding-center{
      padding: 0 45px;
    }

    &__small-padding-center{
      padding: 0 30px;
    }

    &__body{
      padding: 0 0 30px 0;
    }

    table td{
      padding: 5px 0;
    }
  }
</style>

<template>
  <modal
    class="modal"
    :name="name"
    :height="height"
    :width="width"
    :max-width="maxWidth"
    :scrollable="true"
    :adaptive="true"
    @opened="opened"
  >
    <header class="modal__header">
      <a
        class="cursor-pointer float-left"
        @click="closeModal"
      >
        <img
          alt="Close modal icon"
          :src="require('@/assets/img/ico-close.svg')"
        >
      </a>
      <div class="text-center inline-block font-bold">
        {{ title }}
      </div>
      <div
        v-if="hasInfoText"
        class="float-right"
      >
        <v-help-tooltip :options="tooltipContent" />
      </div>
      <div
        class="float-right"
      >
        <v-factual-comment :options="tooltipContent" />
      </div>
      <div
        class="float-right w-0"
      >
        <v-spinner
          class="relative"
          style="bottom: 0.5em; right: 3em;"
          :show="loading"
        />
      </div>
    </header>
    <div class="modal__body">
      <div
        v-if="hasError"
        class="card__error"
      >
        <div>{{ error }}</div>

        <v-button
          icon-left="redo"
          class="btn btn--error"
          @click.prevent="$emit('retry')"
        >
          Retry
        </v-button>
      </div>
      <slot name="content" />
    </div>
  </modal>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
  name: 'VModal',
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      default: 'modal',
    },
    title: {
      type: String,
      default: 'Modal title',
    },
    infoTextKey: {
      type: String,
      default: '',
    },
    enabled: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: 'auto',
    },
    width: {
      type: [Number, String],
      default: 600,
    },
    maxWidth: {
      type: Number,
      default: 460,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, undefined],
      default: '',
    },
  },
  computed: {
    hasInfoText() {
      return this.infoTextKey.length > 0;
    },
    tooltipContent() {
      return {
        key: this.infoTextKey,
      };
    },
    hasError() {
      return this.error && this.error.length > 0;
    },
  },
  methods: {
    closeModal() {
      this.$modal.hide(this.name);
    },
    opened() {
      this.$emit('opened');
    },
  },
};
</script>
